export default __webpack_public_path__ + "static/media/logo.224d3e74.png";